import React, { FC } from "react";

import Tooltip from "@/components/ui/tooltip";

import { Button } from "equator-design-system";
import { twMerge } from "tailwind-merge";

import { MenuItemType } from ".";

type Props = {
  index: number;
  menuItem: MenuItemType;
  isExpand: boolean;
  isActive: boolean;
  // Force the hover look while the matching onboarding step is on screen, so
  // the tour can spotlight this item without the user pointing at it.
  isTourHovered: boolean;
};

const delayClasses: Record<number, string> = {
  0: "delay-300",
  1: "delay-400",
  2: "delay-500",
  3: "delay-600",
  4: "delay-700"
};

const NavItem: FC<Props> = ({
  index,
  menuItem,
  isExpand,
  isActive,
  isTourHovered
}) => {
  const handleClickMenu = () => {
    menuItem.onClick();
  };

  return (
    <Tooltip
      disable={isExpand}
      content={menuItem.name}
      position="right"
      key={menuItem.name}
    >
      <Button
        variant="secondary"
        className={twMerge(
          delayClasses[index % 5],
          "group flex items-center h-[32px] duration-500 text-sm gap-4 font-medium btn-default p-0",
          "!border-none rounded-md hover:bg-teal-50",
          isExpand ? "w-[231px] justify-start bg-black pl-1.5" : "w-[32px]",
          (isActive || isTourHovered) && "!bg-teal-50"
        )}
        onClick={handleClickMenu}
        data-testid={`nav-item-${menuItem.name.toLowerCase().replace(/\s/g, "-")}`}
      >
        {menuItem.icon &&
          React.cloneElement(menuItem.icon as React.ReactElement, {
            className: twMerge(
              (menuItem.icon as React.ReactElement).props.className,
              isActive || isTourHovered ? "fill-teal-500" : "fill-dim-gray",
              "group-hover:fill-teal-500"
            )
          })}
        <span
          className={twMerge(
            "whitespace-pre text-sm font-medium",
            !isExpand && "opacity-0 translate-x-28 overflow-hidden hidden",
            isActive && "text-black font-bold"
          )}
        >
          {menuItem.name}
        </span>
      </Button>
    </Tooltip>
  );
};

export default NavItem;
